import React, {useState,useEffect,useContext} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import {FormValidator,useFormValidator,Inputs} from 'coaz-ui';
import client from '../client'

const AddUser = ({submitRef, setLoading, setEnableSubmit}) => {
    const [userTypes,setUserTypes] = useState([]);
    const [userGroups,setUserGroups] = useState([]);
    const [districts,setDistricts] = useState([]);
    const [nationalities,setNationalities] = useState([]);
    const [professionalCategories,setProfessionalCategories] = useState([]);
    const [idTypes,setIdTypes] = useState([]);
    const [sexes,setSexes] = useState([]);
    const [confirmPassword,setConfirmPassword] = useState('');
    const minWidth = 240;
    const [inputWidth,setInputWidth] = useState(minWidth);
    const [user,setUser] = useState({});
    const {request,errorMessage} = client;

    const onAutoPassword = (e) => {
        let value = !user.autoPassword;
        setUser({...user,autoPassword:value});
    }

    const onChange = (e) => {
        const value = e.target.value;
        if(value === '') {
            setUser({...user, [e.target.name]: null});
        } else {
            setUser({...user, [e.target.name]: value});
        }
    };

    const onName = (e) => {
        const value = e.target.value;
        if(value === '') {
            setUser({...user, name: ''});
        } else {
            setUser({...user, name: value.toLowerCase()});
        }
    };

    const onConfirmPassword = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);
    }; 

    const onUserType = (e) => {
        const value = e.target.value;
        const userType = userTypes.find((userType) => {return userType.ref.id == value});
        if(userType) {
            setUser({...user,userType:userType});
        }
    };

    const onUserGroup = (e) => {
        const value = e.target.value;
        if(value !== '') {
            const userGroup = userGroups.find((userGroup) => {return userGroup.ref.id == value});
            if(userGroup) {
                setUser({...user,userGroup:userGroup});
            }
        } else {
            setUser({...user,userGroup:null});
        }
    };

    const onDateOfBirth = (e) => {
        const value = e.target.value;
        setUser({...user, dateOfBirth: new Date(value)});
    };

    const onDistrict = (e) => {
        const value = e.target.value;
        const district = districts.find((dist) => {return dist.ref.id == value});
        if(district) {
            setUser({...user,district:district});
        }
    };

    const onEmployed = (e) => {
        let value = !user.employed;
        setUser({...user,employed:value});
    }

    const onSubmit = async  () => {
        try {
            const response = await request('POST', 'users', user);

            if (response && response.ref) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
    }

    const [register,handleChange,handleSubmit,errors] = useFormValidator(onSubmit);
    const inputs = [
        {
            label:'Username',
            type:'text',
            name:'name', 
            value:user && user.name?user.name:'',
            placeholder:'Enter username...',
            onChange:(e) => handleChange(e,onName),
            register:register,
            checks:['empty','username'],
            errors:errors
        },
        {
            label:'User Type',
            type:'select',
            options:() => {
                let options = [];
                userTypes.map((option,i) => options.push(<option key={i} value={option.ref.id}>{option.name}</option>));
                return options;
            },
            name:'userType', 
            value:user && user.userType?user.userType.ref.id:'',
            onChange:(e) => handleChange(e,onUserType),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'User Group',
            type:'select',
            options:() => {
                let options = [<option value=''>None</option>];
                userGroups.map((option,i) => options.push(<option key={i} value={option.ref.id}>{option.name}</option>));
                return options;
            },
            name:'userGroup', 
            value:user && user.userGroup?user.userGroup.ref.id:'',
            onChange:(e) => handleChange(e,onUserGroup)
        },
        {
            label:'Auto Generate Password',
            type:'checkbox',
            name:'autoPassword',
            value:user && user.autoPassword,   
            onChange:(e) => onAutoPassword(e)
        },
        {
            label:'Password',
            type:'password',
            name:'password', 
            value:user && user.password?user.password:'',
            disabled:user.autoPassword,
            placeholder:'Enter password...',
            onChange:(e) => handleChange(e,onChange),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Confirm Password',
            type:'password',
            name:'confirmPassword', 
            value:confirmPassword?confirmPassword:'',
            disabled:user.autoPassword,
            placeholder:'Confirm password...',
            onChange:(e) => handleChange(e,onConfirmPassword),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Email',
            type:'text',
            name:'email',
            value:user && user.email?user.email:'',   
            placeholder:'Enter email...',
            onChange:(e) => {handleChange(e,onChange)},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'ID type',
            type:'select',
            options:() => {
                let options = [];
                idTypes.map((option,i) => options.push(<option key={i} value={option}>{option}</option>));
                return options;
            },
            name:'idType', 
            value:user && user.idType?user.idType:'',
            placeholder:'Select ID type...',
            onChange:(e) => handleChange(e,onChange),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'ID number',
            type:'text',
            name:'idNumber', 
            value:user && user.idNumber?user.idNumber:'',
            placeholder:'Enter ID number...',
            onChange:(e) => handleChange(e,onChange),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Firstname',
            type:'text', 
            name:'firstname',
            value:user && user.firstname?user.firstname:'',   
            placeholder:'Enter firstname...',
            onChange:(e) => {handleChange(e,onChange)},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Lastname',
            type:'text',
            name:'lastname', 
            value:user && user.lastname?user.lastname:'',
            placeholder:'Enter lastname...',
            onChange:(e) => handleChange(e,onChange),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Middlename',
            type:'text',
            name:'middlename', 
            value:user && user.middlename?user.middlename:'',
            placeholder:'Enter middlename...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Sex',
            type:'select',
            options:() => {
                let options = [];
                sexes.map((option,i) => options.push(<option key={i} value={option}>{option}</option>));
                return options;
            },
            name:'sex', 
            value:user && user.sex?user.sex:'',
            placeholder:'Select sex...',
            onChange:(e) => handleChange(e,onChange),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Date of Birth',
            type:'date',
            name:'dateOfBirth', 
            value:user && user.dateOfBirth?user.dateOfBirth.toISOString().slice(0, 10):'',
            placeholder:'Pick date of birth...',
            onChange:(e) => handleChange(e,onDateOfBirth)
        },
        {
            label:'Nationality',
            type:'select',
            options:() => {
                let options = [];
                nationalities.map((option,i) => options.push(<option key={i} value={option}>{option}</option>));
                return options;
            },
            name:'nationality', 
            value:user && user.nationality?user.nationality:'',
            placeholder:'Select nationality...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Phone 1',
            type:'text',
            name:'phone1', 
            value:user && user.phone1?user.phone1:'',
            placeholder:'Enter phone 1...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Phone 2',
            type:'text',
            name:'phone2', 
            value:user && user.phone2?user.phone2:'',
            placeholder:'Enter phone 2...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Physical address',
            type:'text',
            name:'physicalAddress', 
            value:user && user.physicalAddress?user.physicalAddress:'',
            placeholder:'Enter physical address...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Postal Address',
            type:'text',
            name:'postalAddress', 
            value:user && user.postalAddress?user.postalAddress:'',
            placeholder:'Enter postal address...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'District',
            type:'select',
            options:() => {
                let options = [];
                districts.map((option,i) => options.push(<option key={i} value={option.ref.id}>{option.name}</option>));
                return options;
            },
            name:'district', 
            value:user && user.district?user.district.ref.id:'',
            placeholder:'Select district...',
            onChange:(e) => handleChange(e,onDistrict)
        },
        {
            label:'Program',
            type:'text', 
            name:'program',
            value:user && user.program?user.program:'',   
            placeholder:'Enter program...',
            onChange:(e) => {handleChange(e,onChange)}
        },
        {
            label:'Institution',
            type:'text',
            name:'institution', 
            value:user && user.institution?user.institution:'',
            placeholder:'Enter Institution...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Professional Category',
            type:'select',
            options:() => {
                let options = [<option value={''}>None</option>];
                professionalCategories.map((option,i) => options.push(<option key={i} value={option}>{option}</option>));
                return options;
            },
            name:'professionalCategory', 
            value:user && user.professionalCategory?user.professionalCategory:'',
            placeholder:'Select professional category...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Employed',
            type:'checkbox', 
            name:'employed',
            value:user?user.employed:'',   
            onChange:(e) => onEmployed(e)
        },
        {
            label:'Employer',
            type:'text',
            name:'employer', 
            value:user && user.employer?user.employer:'',
            disabled:user?!user.employed:true,
            placeholder:'Enter employer...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Employee Id',
            type:'text',
            name:'employeeId', 
            value:user && user.employeeId?user.employeeId:'',
            disabled:user?!user.employed:true,
            placeholder:'Enter employee id...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Organizational Unit',
            type:'text',
            name:'organizationalUnit', 
            value:user && user.organizationalUnit?user.organizationalUnit:'',
            disabled:user?!user.employed:true,
            placeholder:'Enter organizational unit...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Current Position',
            type:'text',
            name:'currentPosition', 
            value:user && user.currentPosition?user.currentPosition:'',
            disabled:user?!user.employed:true,
            placeholder:'Enter current position...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Facility',
            type:'text',
            name:'facility', 
            value:user && user.facility?user.facility:'',
            disabled:user?!user.employed:true,
            placeholder:'Enter facility...',
            onChange:(e) => handleChange(e,onChange)
        }
    ]

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        ( async () => {
            setLoading && setLoading(true);
            let userType = null;
            await request('GET','usertypes')
            .then((response) => {
                if(response && response.length > 0) {
                    setUserTypes(response);
                    userType = response[0];
                }  else {
                    setUserTypes([]);
                }
            })
            .catch((error) => {
                setUserTypes([]);
            })
            await request('GET','usergroups')
            .then((response) => {
                if(response && response.length > 0) {
                    setUserGroups(response);
                }  else {
                    setUserGroups([]);
                }
            })
            .catch((error) => {
                setUserGroups([]);
            })
            let district = null;
            await request('GET','districts')
            .then((response) => {
                if(response && response.length > 0) {
                    response.sort(function(a, b) {
                        if (a.name < b.name) {
                            return -1; // a comes before b
                        }
                        if (a.name > b.name) {
                            return 1;  // b comes before a
                        }
                        return 0;      // names are equal, maintain relative order
                    });
                    setDistricts(response);
                    district = response[0];
                }  else {
                    setDistricts([]);
                }
            })
            .catch((error) => {
                setDistricts([]);
            })
            let nationality = null
            await request('GET','nationalities')
            .then((response) => {
                if(response && response.length > 0) {
                    setNationalities(response);
                    let zambia = response.find(nation => {return nation.toLowerCase() === 'zambian'});
                    nationality = zambia?zambia:response[0];
                }  else {
                    setNationalities([]);
                }
            })
            .catch((error) => {
                setNationalities([]);
            })
            await request('GET','professionalcategories')
            .then((response) => {
                if(response && response.length > 0) {
                    setProfessionalCategories(response);
                }  else {
                    setProfessionalCategories([]);
                }
            })
            .catch((error) => {
                setProfessionalCategories([]);
            })
            let idType = null;
            await request('GET','idtypes')
            .then((response) => {
                if(response && response.length > 0) {
                    setIdTypes(response);
                    idType = response[0];
                }  else {
                    setIdTypes([]);
                }
            })
            let sex = null;
            await request('GET','sexes')
            .then((response) => {
                if(response && response.length > 0) {
                    setSexes(response);
                    sex = response[0];
                }  else {
                    setSexes([]);
                }
            })
            setUser({
                ...user,
                userType:userType,
                sex:sex,
                district:district,
                nationality:nationality,
                dateOfBirth: new Date(),
                idType:idType
            });
            setLoading && setLoading(false);
        }
        )();
    },[]);

  return (
    <FormValidator>
        <div className='w-full h-auto shrink-0'>
            <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
        </div>
    </FormValidator>
  )
}

export default AddUser